import { useContext } from "react";
import { motion } from "framer-motion";
import { EASE, InstantContext, MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";

const Bar = ({ height, value, label, gold, delay }) => {
  const instant = useContext(InstantContext);
  return (
    <div className="flex flex-col items-center">
      <span
        className={`tnum mb-3 font-serif text-2xl sm:text-3xl ${gold ? "text-[#D4AF37]" : "text-white/60"}`}
      >
        {value}
      </span>
      <motion.div
        initial={instant ? false : { height: 0 }}
        animate={{ height }}
        transition={{ duration: 1.2, delay: instant ? 0 : delay, ease: EASE }}
        className={`w-24 sm:w-32 ${
          gold
            ? "bg-gradient-to-t from-[#997A15] via-[#D4AF37] to-[#F3E5AB]"
            : "border border-white/10 bg-[#334155]/50"
        }`}
      />
      <span className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-white/45">{label}</span>
    </div>
  );
};

export default function Slide09CaseHistory() {
  return (
    <SlideShell theme="navy" testid="slide-9-case-history">
      <SlideBody>
        <div className="grid items-center gap-14 lg:grid-cols-[1.15fr_1fr]">
          <div>
            <Reveal>
              <Micro>08 · Case History</Micro>
            </Reveal>
            <h2 className="mt-5 font-serif text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
              <MaskedLine delay={0.1}>
                LA <em className="italic text-[#D4AF37]">BALENA BLU.</em>
              </MaskedLine>
            </h2>
            <div data-testid="bar-chart-case-history" className="mt-12">
              <div className="flex items-end justify-start gap-10 border-b border-white/15 pb-0 sm:gap-16">
                <Bar height={120} value="≈ €6.000" label="Ago 2025" delay={0.5} />
                <Bar height={300} value="> €15.000" label="Ago 2026*" gold delay={0.75} />
              </div>
              <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">
                Ricavi da servizi aggiuntivi · mese di agosto
              </p>
            </div>
          </div>
          <div>
            <Reveal delay={1.05}>
              <div className="tnum font-serif text-[96px] leading-none tracking-tight text-[#D4AF37] lg:text-[150px]">
                +150%
              </div>
              <p className="mt-6 max-w-sm text-base leading-relaxed text-[#94A3B8]">
                Crescita dei ricavi da servizi aggiuntivi con il Guest Portal attivo: stessa villa,
                stesse prenotazioni, più valore per soggiorno.
              </p>
              <p className="mt-8 font-mono text-[10px] uppercase leading-relaxed tracking-[0.25em] text-white/35">
                *Proiezione su consuntivo 2025 · servizi aggiuntivi · agosto
              </p>
            </Reveal>
          </div>
        </div>
      </SlideBody>
    </SlideShell>
  );
}
